import React from 'react';
import ContactUs from '../components/ContactUs';

export default function Contact() {
  return <ContactUs />;
}
